<template>
  <div>
    <v-btn
      right
      bottom
      fixed
      color="success"
      fab
      :to="{ name: 'FinanceInvoicesSubmittedAdd' }"
      ><v-icon>mdi-plus</v-icon></v-btn
    >

    <template v-if="groupMode">
      <template v-for="(item, index) in itemsFilteredGrouping">
        <v-system-bar :key="'bar' + index"
          ><span>{{ item.key }}</span
          ><v-spacer />
        </v-system-bar>
        <TableComponent
          :items="item.items"
          :key="'table' + index"
          :loading="loading"
          @showDetails="showDetails"
          @showGroup="showGroup"
          @showEdit="showEdit"
          @groupInvoices="groupInvoices"
          showSelect
          :itemsPerPage="-1"
          grouping
        >
        </TableComponent>
      </template>
    </template>
    <TableComponent
      v-else
      :items="itemsFiltered"
      :loading="loading"
      @showDetails="showDetails"
      @showGroup="showGroup"
      @showEdit="showEdit"
      @groupInvoices="groupInvoices"
      showSelect
      :itemsPerPage="-1"
      group
      grouping
    >
    </TableComponent>
    <v-toolbar flat>
      <v-switch
        inset
        class="mr-2"
        outlined
        color="info"
        v-model="groupMode"
        label="Gruppieren-Modus"
        hideDetails
      >
      </v-switch>
    </v-toolbar>
    <router-view
      @update="update"
      @showDetails="showDetails"
      @showEdit="showEdit"
    ></router-view>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { searchPerson } from "common/utils/people.js";
import TableComponent from "./TableComponent.vue";

export default defineComponent({
  name: "FinanceInvoices",
  components: {
    TableComponent,
  },
  props: ["search"],
  data() {
    return {
      groupMode: false,
      items: [],
      loading: false,
    };
  },
  computed: {
    itemsFiltered() {
      if (!this.search) {
        return this.items;
      }
      return this.items.filter(
        (el) =>
          el.number.toLowerCase().startsWith(this.search.toLowerCase()) ||
          (el.group &&
            el.group.number
              .toLowerCase()
              .startsWith(this.search.toLowerCase())) ||
          el.amount.toFixed(2) == parseFloat(this.search).toFixed(2) ||
          el.amountForeign.toFixed(2) == parseFloat(this.search).toFixed(2) ||
          searchPerson(el.employee, this.search)
      );
    },
    itemsFilteredGroupable() {
      return this.items.filter(
        (el) => !el.group && el.iban && el.currency.local && !el.noDetails
      );
    },
    itemsFilteredGrouping() {
      const result = [];
      for (const item of this.itemsFilteredGroupable) {
        const key = `${item.iban} (${item.account.description})`;
        let group = result.find((el) => el.key === key);
        if (!group) {
          group = {
            key: key,
            items: [],
          };
          result.push(group);
        }
        group.items.push(item);
      }
      return result;
    },
  },
  methods: {
    update() {
      this.fetchData();
      this.$emit("update");
    },
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/invoice",
        query: `status=submitted`,
      });
      this.loading = false;
    },
    async groupInvoices(ids) {
      this.loading = true;
      const group = await this.apiPost({
        resource: "finance/invoicegroup",
        data: { ids: ids },
      });
      this.fetchData();
      this.showGroup(group.id);
    },
    showEdit(id) {
      this.$router.push({
        name: "FinanceInvoicesSubmittedEdit",
        params: { id: id },
      });
    },
    showDetails(id) {
      this.$router.push({
        name: "FinanceInvoicesSubmittedDetail",
        params: { id: id },
      });
    },
    showGroup(id) {
      this.$router.push({
        name: "FinanceInvoicesSubmittedGroup",
        params: { id: id },
      });
    },
  },
  async created() {
    await this.fetchData();
  },
});
</script>
